<template>
  <footer class="app-footer">
    <div class="menubar-area style-7 footer-fixed rounded-0">
      <div class="toolbar-inner menubar-nav footer-menu-centered">
        <router-link to="/" class="nav-link">
          <i class="fa fa-home"></i>
          <span @click="myFunction">Home</span>
        </router-link>
        <router-link to="/keranjang" class="nav-link">
          <i class="fa fa-solid fa-shopping-bag"></i>
          <span>Cart</span>
        </router-link>
        <router-link to="/login" class="nav-link">
          <i class="fa fa-solid fa-user"></i>
          <span>Account</span>
        </router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterItem",
  data() {
    return {
      alamat: window.location.href,
      alam: "",
    };
  },
  methods: {
    myFunction() {
      this.alam = this.alamat.substring(27, 4);
    },
  },

  computed: {
    currentRouteName() {
      return this.$route.path;
    },
  },
};
</script>

<style scoped>
.footer-menu-centered {
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer-menu-centered .nav-link {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
